import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import socket from './modules/socket'

Vue.use(Vuex)
export default new Vuex.Store({
    modules: {
        user,
        socket,
    },
})